/*
 * @Author: bbqin
 * @Date: 2023-02-18 10:27:07
 * @LastEditTime: 2023-07-11 16:24:45
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\card\store.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { BaseStore, hookFactory } from '@platform/template';
import { isObject } from "@platform/api";
import { isArray } from "../../libs/utils";

// 组装数据
const pathName = 'LowCodeComponents.NCTabs';

class Store extends BaseStore {
    constructor(props = {}) {
        super(props);
        this.name = "singleCardStore";
        this.setStore("id", props.id, false);
        this.setStore("props", props.props, false);
    }

    // 数据源
    store = {
        id: '',
        cardInstance: null,
        props: {},
    };

    /**
     * @description: 复写
     * @param {type}
     * @returns {object}
     */
    getStore(paths) {
        return super.get(paths);
    }

    /**
     * @description: 复写
     * @param {type}
     * @returns {object}
     */
    setStore(paths, value, shouldForceUpdate = true, callback) {
        let res = super.set(paths, value);
        shouldForceUpdate ? this.forceUpdate(callback) : callback && callback();
        return res;
    }

    /**
     * TODO
     * 获取卡片属性
     * @param {string} key 
     */
    getCardProps(key) {
        let value = null;
        if (!key) {
            value = this.getStore('props') || {};
            return value;
        }
        key = isArray(key) ? key : [key];
        value = this.getStore(['props', ...key]);
        return value;
    }

    /**
     * TODO
     * 卡片的属性
     * @param {string} cardId 
     * @param {string} key 
     * @param {any} value 
     * @param {boolean} shouldForceUpdate 
     */
    setCardProps(key, value, shouldForceUpdate, { callback } = {}) {
        key = isArray(key) ? key : [key];
        this.setStore(['props', ...key], value, shouldForceUpdate, callback);
    }

    /**
     * TODO
     * 卡片的属性
     * @param {string} cardId 
     * @param {string} key 
     * @param {any} value 
     * @param {boolean} shouldForceUpdate 
     */
    updateCardProps(props, shouldForceUpdate, callback) {
        const currentProps = this.getStore(['props']);
        const nextProps = { ...currentProps, ...props };
        this.setStore(['props'], nextProps, shouldForceUpdate, callback);
    }

    /**
     * TODO
     * 获取卡片实例
     * @param {string} cardId
     */
    getCardInstance() {
        let value = this.getStore(['cardInstance']);
        return value;
    }

    /**
     * @description: 钩子
     * @param {type} 
     * @returns {object}
     */
    getHooks = () => {
        // 这样处理的一下 才能报错  方法内部的this 永远指向 实例  否则会指向下面的 {} 对象
        // this.getMeta = this.getMeta.bind(this);
        // this.setMeta = this.setMeta.bind(this);

        return {
            // 这个是给公共层提供 组件在使用baseComponent 是可以正常运行
            setRef: this.setRef,
            getRef: this.getRef,
            removeRef: this.removeRef,

            // 按路径索引 给内部使用
            getStore: this.getStore.bind(this),
            setStore: this.setStore.bind(this),

            /*-------------------上面的部分------------------*/
            // 卡片
            getCardProps: this.getCardProps.bind(this),
            setCardProps: this.setCardProps.bind(this),
            updateCardProps: this.updateCardProps.bind(this),
            getCardInstance: this.getCardInstance.bind(this),
        };
    };
}

export default hookFactory(Store);